var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"imgs"},_vm._l((_vm.imgs),function(item,index){return _c('img',{key:index,attrs:{"src":item}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }